{
  "eyebrow": "Sveiki",
  "title": "Sveiki atvykę į Done-it, {{company}}.",
  "titleGeneric": "Sveiki atvykę į Done-it.",
  "sub": "Jūsų 30 dienų {{plan}} bandymas aktyvus. Trys kiti žingsniai.",
  "subGeneric": "Jūsų paskyra aktyvi. Trys tolesni žingsniai.",
  "next1": {
    "title": "Atsisiųskite mobiliąją programėlę",
    "desc": "Nusiųskite komandai diegimo nuorodą SMS arba el. paštu.",
    "cta": "Siųsti kvietimo nuorodą"
  },
  "next2": {
    "title": "Pakvieskite savo komandą",
    "desc": "Importuokite darbuotojus iš CSV arba pridėkite po vieną.",
    "cta": "Atidaryti administratorių"
  },
  "next3": {
    "title": "Pažiūrėkite 4 minučių apžvalgą",
    "desc": "Pamatykite, kaip nustatyti pirmą projektą ir vietas.",
    "cta": "Žiūrėti vaizdo įrašą"
  },
  "cta": "Į skydelį",
  "receipt": "Kvitas ir įžanginis el. laiškas keliauja į {{email}}.",
  "receiptGeneric": "Kvitas ir įžanginis el. laiškas jau pakeliui.",
  "fallbacks": {
    "company": "jūsų įmonė",
    "plan": "jūsų planas",
    "inbox": "jūsų pašto dėžutė"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Jūsų „{{plan}}“ paskyra aktyvi — nemokama visam laikui. Trys tolesni žingsniai."
}
